import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Home from '@/components/Home'
import Login from '@/components/Login'
import AccessDenied from '@/components/AccessDenied'
import RoleGroupsList from '@/components/views/roleGroups/RoleGroupsList'
import RoleGroupsDetail from '@/components/views/roleGroups/RoleGroupsDetail'
import RoleGroupsNew from '@/components/views/roleGroups/RoleGroupsNew'
import RoleGroupsDetailBasicInfo from '@/components/views/roleGroups/detail/BasicInfo'
import RoleGroupsDetailUsers from '@/components/views/roleGroups/detail/Users'
import OperatorNew from '@/components/views/operators/OperatorNew'
import OperatorList from '@/components/views/operators/OperatorList'
import OperatorDetail from '@/components/views/operators/OperatorDetail'
import SubscriberNew from '@/components/views/subscribers/SubscriberNew'
import SubscriberList from '@/components/views/subscribers/SubscriberList'
import SubscriberDetail from '@/components/views/subscribers/SubscriberDetail'
import SubscriberDetailSettings from '@/components/views/subscribers/settings/SettingsTab.vue'
import SubscriberDetailBiller from '@/components/views/subscribers/biller/Biller.vue'
import SubscriberDetailServices from '@/components/views/subscribers/servicesList/ServicesList.vue'
import SubscriberDetailDevices from '@/components/views/subscribers/devices/Devices.vue'
import SubscriberDetailProfiles from '@/components/views/subscribers/profiles/Profiles.vue'
import SubscriberDetailChannelGroups from '@/components/views/subscribers/channelGroups/ChannelGroups.vue'
import SubscriberDetailPvrs from '@/components/views/subscribers/pvrs/Pvrs.vue'
import SubscriberDetailPeriodicPvrs from '@/components/views/subscribers/periodicPvrs/PeriodicPvrs.vue'
import SubscriberDetailFavoriteShows from '@/components/views/subscribers/favoriteShows/FavoriteShows.vue'
import SubscriberDetailMessages from '@/components/views/subscribers/messages/Messages.vue'
import SubscriberDetailAdvertisingBanners from '@/components/views/subscribers/advertisingBanners/AdvertisingBanners.vue'
// dočasně skryto (TW 36504111)
// import SubscriberDetailNotifications from '@/components/views/subscribers/subscriberNotifications/SubscriberNotifications.vue'
import SubscriberDetailDashboard from '@/components/views/subscribers/dashboard/Dashboard.vue'
import SubscriberDetailRestrictedChannels from '@/components/views/subscribers/restrictedChannels/RestrictedChannels.vue'
import SubscriberDetailPurchasedVodVideos from '@/components/views/subscribers/purchasedVodVideos/PurchasedVodVideos.vue'
import SubscriberProfileDetail from "../components/views/subscriberProfile/SubscriberProfileDetail.vue";
import SubscriberProfileNew from "../components/views/subscriberProfile/SubscriberProfileNew.vue";
import ForgottenPassword from '@/components/ForgottenPassword'
import ChannelList from '@/components/views/channels/ChannelList'
import ChannelDetail from '@/components/views/channels/ChannelDetail'
import PackageList from '@/components/views/packages/PackageList'
import PackageNew from '@/components/views/packages/PackageNew'
import PackageDetail from '@/components/views/packages/PackageDetail'
import UserList from '@/components/views/users/UserList'
import UserNew from '@/components/views/users/UserNew'
import UserDetail from '@/components/views/users/UserDetail'
import BillerList from '@/components/views/billers/BillerList'
import BillerNew from '@/components/views/billers/BillerNew'
import BillerDetail from '@/components/views/billers/BillerDetail'
import BillerDetailSubscriberList from '@/components/views/billers/billerDetail/SubscriberList'
import BillerDetailDeviceList from '@/components/views/billers/billerDetail/DeviceList'
import BillerDetailServiceList from '@/components/views/billers/billerDetail/ServiceList'
import ServiceList from '@/components/views/services/ServiceList'
import ServiceNew from '@/components/views/services/ServiceNew'
import ServiceDetail from '@/components/views/services/ServiceDetail'
import Downloads from '@/components/views/downloads/Downloads'
import ContentSourceList from '@/components/views/contentsources/ContentSourceList'
import ContentSourceDetail from '@/components/views/contentsources/ContentSourceDetail'
import ContentSourceNew from '@/components/views/contentsources/ContentSourceNew'
import ContentSourceContentNew from "@/components/views/contentsources/content/ContentSourceContentNew"
import ContentSourceMaintenanceWindowLists from "../components/views/contentSourceMaintenanceWindow/ContentSourceMaintenanceWindowLists.vue";
import ContentSourceMaintenanceWindowNew from "../components/views/contentSourceMaintenanceWindow/ContentSourceMaintenanceWindowNew.vue";
import ContentSourceMaintenanceWindowDetail from "../components/views/contentSourceMaintenanceWindow/ContentSourceMaintenanceWindowDetail.vue";
import ReportsList from "../components/views/reports/ReportsList"
import ReportsOperatorList from "../components/views/reports/ReportsOperatorList"
import Optimization from "@/components/views/optimization/Optimization"
import CronList from "@/components/views/crons/CronList"
import CronDetail from "@/components/views/crons/CronDetail"
import CronRunLog from "@/components/views/crons/CronRunLog"
import CodecsList from "@/components/views/codecs/CodecsList"
import ProtocolList from "@/components/views/protocols/ProtocolsList"
import ProtocolNew from "@/components/views/protocols/ProtocolNew"
import ProtocolDetail from "@/components/views/protocols/ProtocolDetail"
import BusinessModelList from "../components/views/businessModels/BusinessModelList"
import BusinessModelNew from "../components/views/businessModels/BusinessModelNew"
import BusinessModelDetail from "../components/views/businessModels/BusinessModelDetail"
import MessageTemplateList from "../components/views/messagetemplates/MessageTemplateList"
import MessageTemplateNew from "../components/views/messagetemplates/MessageTemplateNew"
import MessageTemplateDetail from "../components/views/messagetemplates/MessageTemplateDetail"
import MessageList from "../components/views/messages/MessageList"
import MessageDetail from "../components/views/messages/MessageDetail"
import MessageNew from "../components/views/messages/MessageNew"
import BrandsList from "../components/views/brands/BrandsList";
import BrandNew from "../components/views/brands/BrandNew";
import BrandDetail from "../components/views/brands/BrandDetail";
import StreamProfilesList from "../components/views/streamProfiles/StreamProfilesList";
import StreamProfileNew from "../components/views/streamProfiles/StreamProfileNew";
import StreamProfileDetail from "../components/views/streamProfiles/StreamProfileDetail";
import ServiceWeightCategoryNew from "../components/views/serviceWeightCategories/ServiceWeightCategoryNew";
import ServiceWeightCategoriesList from "../components/views/serviceWeightCategories/ServiceWeightCategoriesList";
import ServiceWeightCategoryDetail from "../components/views/serviceWeightCategories/ServiceWeightCategoryDetail";
import AdminConfigurationDetail from "../components/views/adminConfiguration/AdminConfigurationDetail";
import LocalitiesList from "../components/views/localities/LocalitiesList"
import LocalitiesDetail from "../components/views/localities/LocalitiesDetail"
import LocalitiesNew from "../components/views/localities/LocalitiesNew"
import DeviceTypeEvaluationsContainer from "@/components/views/deviceTypeEvaluations/DeviceTypeEvaluationsContainer"
import DeviceTypeEvaluationsList from "@/components/views/deviceTypeEvaluations/DeviceTypeEvaluationsList"
import DeviceTypeEvaluationTester from "@/components/views/deviceTypeEvaluations/DeviceTypeEvaluationTester"
import DeviceTypeEvaluationNew from "@/components/views/deviceTypeEvaluations/DeviceTypeEvaluationNew"
import DeviceTypeEvaluationDetail from "@/components/views/deviceTypeEvaluations/DeviceTypeEvaluationDetail"
import DeviceTypesList from "@/components/views/deviceTypes/DeviceTypesList"
import DeviceTypeNew from "@/components/views/deviceTypes/DeviceTypeNew"
import DeviceTypeDetail from "@/components/views/deviceTypes/DeviceTypeDetail"
import DeviceTypeNewDescription from "@/components/views/deviceTypes/components/Description"
import DeviceTypeNewStreamProfiles from "@/components/views/deviceTypes/components/StreamProfiles"
import DeviceProfilesList from "@/components/views/deviceProfiles/DeviceProfilesList"
import DeviceProfileDetail from "@/components/views/deviceProfiles/DeviceProfileDetail"
import DeviceProfileDetailBasic from "@/components/views/deviceProfiles/forms/BasicSettings"
import DeviceProfileDetailProtocols from "@/components/views/deviceProfiles/forms/ProtocolSettings"
import DeviceProfileDetailLinearProtocols from "@/components/views/deviceProfiles/forms/LinearProtocols"
import DeviceProfileDetailNonLinearProtocols from "@/components/views/deviceProfiles/forms/NonLinearProtocols"
import DeviceProfileNew from "@/components/views/deviceProfiles/DeviceProfileNew"

import DeviceConfigsList from "@/components/views/deviceConfigs/DeviceConfigsList"
import DeviceConfigNew from "@/components/views/deviceConfigs/DeviceConfigNew"
import DeviceConfigDetail from "@/components/views/deviceConfigs/DeviceConfigDetail"
import DeviceConfigDetailBasic from "@/components/views/deviceConfigs/forms/BasicSettings"
import DeviceConfigDetailFeatures from "@/components/views/deviceConfigs/forms/Features"
import DeviceConfigDetailPlayer from "@/components/views/deviceConfigs/forms/Player"
import DeviceConfigDetailPlatform from "@/components/views/deviceConfigs/forms/Platform"
import DeviceConfigDetailDevice from "@/components/views/deviceConfigs/forms/Device"

import DeviceDetail from "../components/views/devices/DeviceDetail"
import DeviceDetailDashboard from "../components/views/devices/detail/Dashboard"
import DeviceDetailActivity from "../components/views/devices/detail/Activity"
import DeviceDetailHistory from "../components/views/devices/detail/DeviceHistory"
import DeviceDetailChannels from "../components/views/devices/detail/Channels"
import DeviceDetailChannelGroups from "../components/views/devices/detail/ChannelGroups"
import DeviceDetailMacAddresses from "../components/views/devices/detail/MacAddresses"
import DeviceDetailBootConfigs from "../components/views/devices/detail/DeviceBootConfigs"
import DeviceDetailMetadata from "../components/views/devices/detail/DeviceMetadata"
import ChannelGroupDetail from "../components/views/channelGroups/channelGroupDetail"
import DevicesList from "../components/views/devices/DevicesList"
import TagsList from "@/components/views/tags/TagsList"
import OperatorTagsList from "@/components/views/operatorTags/OperatorTagsList"
import DashboardCarouselList from "../components/views/dashboardCarousels/DashboardCarouselList";
import DashboardCarouselDetail from "../components/views/dashboardCarousels/DashboardCarouselDetail";
import DashboardCarouselNew from "../components/views/dashboardCarousels/DashboardCarouselNew";
import CustomExportList from "../components/views/customExports/CustomExportList";
import CustomExportDetail from "../components/views/customExports/CustomExportDetail";
import RegisteredMacAddressBatchList from "../components/views/registeredMacAddress/RegisteredMacAddressBatchList"
import RegisteredMacAddressBatchDetail from "../components/views/registeredMacAddress/RegisteredMacAddressBatchDetail";
import RegisteredMacAddressBatchNew from "../components/views/registeredMacAddress/RegisteredMacAddressBatchNew";
import UnregisteredMacAddressList from "../components/views/registeredMacAddress/UnregisteredMacAddressList";
import BatchList from "../components/views/registeredMacAddress/BatchList";
import MacAddressList from "../components/views/registeredMacAddress/MacAddressList";
import VersionRedirectList from "../components/views/versionRedirect/VersionRedirectList"
import VersionRedirectNew from "../components/views/versionRedirect/VersionRedirectNew"
import VersionRedirectDetail from "../components/views/versionRedirect/VersionRedirectDetail"
import AdvertisingBannerList from "../components/views/advertisingBanner/AdvertisingBannerList.vue";
import AdvertisingBannerNew from "../components/views/advertisingBanner/AdvertisingBannerNew.vue";
import AdvertisingBannerDetail from "../components/views/advertisingBanner/AdvertisingBannerDetail.vue";
import AdvertisingBannerDetailSettings from "../components/views/advertisingBanner/Detail/Settings.vue";
import AdvertisingBannerDetailRecipients from "../components/views/advertisingBanner/Detail/Recipients.vue";
import ThematicGroupList from "../components/views/thematicGroups/ThematicGroupList.vue";
import ThematicGroupNew from "../components/views/thematicGroups/ThematicGroupNew.vue";
import ThematicGroupDetail from "../components/views/thematicGroups/ThematicGroupDetail.vue";
import InitialProcessSetupList from "../components/views/initialProcessSetup/InitialProcessSetupList.vue";
import InitialProcessSetupDetail from "../components/views/initialProcessSetup/InitialProcessSetupDetail.vue";
import InitialProcessSetupNew from "../components/views/initialProcessSetup/InitialProcessSetupNew.vue";
import BlackoutContentList from "../components/views/blackoutContents/BlackoutContentList.vue";
import BlackoutContentNew from "../components/views/blackoutContents/BlackoutContentNew.vue";
import BlackoutContentDetail from "../components/views/blackoutContents/BlackoutContentDetail.vue";
import VodProvidersList from "../components/views/vodProviders/VodProvidersList.vue";
import VodProvidersDetail from "../components/views/vodProviders/VodProvidersDetail.vue";
import VodProvidersSettings from "../components/views/vodProviders/detail/Settings.vue";
import VodProvidersPackages from "../components/views/vodProviders/detail/Packages.vue";
import VodProvidersVideos from "../components/views/vodProviders/detail/Videos.vue";
import VodPackagesList from "../components/views/vodPackages/VodPackagesList.vue";
import VodPackagesDetail from "../components/views/vodPackages/VodPackagesDetail.vue";
import VodPackagesSettings from "../components/views/vodPackages/detail/Settings.vue";
import VodPackagePrices from "../components/views/vodPackages/detail/Prices.vue";
import VodPackagesServices from "../components/views/vodPackages/detail/Services.vue";
import VodVideosList from "../components/views/vodVideos/VodVideosList.vue";
import VodVideosDetail from "../components/views/vodVideos/VodVideosDetail.vue";
import VodVideosSettings from "../components/views/vodVideos/detail/Settings.vue";
import VodVideoPrices from "../components/views/vodVideos/detail/Prices.vue";
import CurrenciesList from "../components/views/currencies/CurrenciesList.vue";
import CurrenciesDetail from "../components/views/currencies/CurrenciesDetail.vue";
import VodEpisodesList from "../components/views/vodEpisodes/VodEpisodesList.vue";
import AdvertisingProvidersList from "../components/views/advertisingProviders/AdvertisingProvidersList.vue";
import AdvertisingProviderNew from "../components/views/advertisingProviders/AdvertisingProviderNew.vue";
import AdvertisingProviderDetail from "../components/views/advertisingProviders/AdvertisingProviderDetail.vue";
import AdvertisingProviderSettings from "../components/views/advertisingProviders/detail/Settings.vue";
import AdvertisingProviderChannelGroupsList from "../components/views/advertisingProviders/detail/ChannelGroupsList.vue";
import AdvertisingProviderChannelGroupDetail from "../components/views/advertisingProviders/channelGroup/ChannelGroupDetail.vue"
import AdvertisingProviderChannelGroupDetailSettings from "../components/views/advertisingProviders/channelGroup/Settings.vue"
import AdvertisingProviderChannelGroupDetailChannelsList from "../components/views/advertisingProviders/channelGroup/ChannelsList.vue"
import DeviceBootConfigsList from "../components/views/deviceBootConfigs/DeviceBootConfigsList.vue";
import DeviceBootConfigDetail from "../components/views/deviceBootConfigs/DeviceBootConfigDetail.vue";
import DeviceBootConfigNew from "../components/views/deviceBootConfigs/DeviceBootConfigNew.vue";
import LandingPage from "../components/views/landingPage/LandingPage.vue";
import LandingPageForm from "../components/views/landingPage/LandingPageForm.vue";
import ImagesList from "../components/views/images/ImagesList.vue";
import ImageNew from "../components/views/images/ImageNew.vue";
import ImageDetail from "../components/views/images/ImageDetail.vue";
import { SET_SETTING } from "../store/mutation-types";

Vue.use(Router)

const OPERATOR = 'ROLE_OPERATOR'

const router = new Router({
	//mode: 'history',
	routes: [
		{
			name: 'login',
			path: '/login',
			component: Login,
			meta: {requiresAuth: false},
		},
		{
			name: 'forgotten-password',
			path: '/forgotten-password',
			component: ForgottenPassword,
			meta: {requiresAuth: false},
		},
		{
			name: 'home',
			path: '/',
			component: Home,
			meta: {requiresAuth: true},
			children: [
				{
					name: 'access-denied',
					path: 'access-denied',
					component: AccessDenied,
					meta: {requiresAuth: false}
				},
				// ADMIN CONFIGURATION
				{
					name: 'adminConfiguration',
					path: 'adminConfiguration',
					component: AdminConfigurationDetail,
					meta: { requiresAuth: true, sectionName: 'adminConfiguration'}
				},
				// ROLES
				{
					name: 'roleGroups',
					path: 'roleGroups',
					component: RoleGroupsList,
					meta: { requiresAuth: true, sectionName: 'roleGroups', remember: true }
				},
				{
					name: 'roleGroupsNew',
					path: 'roleGroups/new',
					component: RoleGroupsNew,
					meta: { requiresAuth: true, sectionName: 'roleGroups', action: 'create'}
				},
				{
					name: 'roleGroupsDetail',
					path: 'roleGroups/:id',
					component: RoleGroupsDetail,
					meta: {requiresAuth: true, sectionName: 'roleGroups'},
					children: [
						{
							name: 'roleGroupsDetailBasicInfo',
							path: 'basicInfo',
							component: RoleGroupsDetailBasicInfo,
							meta: {sectionName: 'roleGroups'}
						},
						{
							name: 'roleGroupsDetailUsers',
							path: 'users',
							component: RoleGroupsDetailUsers,
							meta: {sectionName: 'users'}
						},
					]
				},
				// OPTIMIZATION
				{
					name: 'optimization',
					path: 'optimization',
					component: Optimization,
					meta: {requiresAuth: true, sectionName: 'optimization', action: 'update'}
				},
				// CRON
				{
					name: 'crons',
					path: 'crons',
					component: CronList,
					meta: {requiresAuth: true, sectionName: 'crons', remember: true}
				},
				{
					name: 'cronDetail',
					path: 'crons/:id',
					component: CronDetail,
					meta: {requiresAuth: true, sectionName: 'crons'},
					beforeEnter: (to, from, next) => {
						if (from.name === 'cronRunLog') {
							next({
								name: 'cronDetailHistory',
								params: to.params
							})
						} else {
							next()
						}
					}
				},
				{
					name: 'cronDetailHistory',
					path: 'crons/:id/history',
					component: CronDetail,
					meta: {requiresAuth: true, sectionName: 'crons'}
				},
				{
					name: 'cronRunLog',
					path: 'crons/runs/:id',
					component: CronRunLog,
					meta: {requiresAuth: true, sectionName: 'crons'}
				},
				// REGISTERED MAC ADDRESS
				{
					name: 'registeredMacAddressBatchNew',
					path: 'registeredMacAddressBatches/new',
					component: RegisteredMacAddressBatchNew,
					props: true,
					meta: {requiresAuth: true, sectionName: 'registeredMacs'},
				},
				{
					name: 'registeredMacAddressBatches',
					path: 'registeredMacAddressBatches',
					component: RegisteredMacAddressBatchList,
					meta: {requiresAuth: true, sectionName: 'registeredMacs', remember: true},
					children: [
						{
							name: 'batchList',
							path: 'batchList',
							component: BatchList,
							meta: {sectionName: 'registeredMacs'},
						},
						{
							name: 'macAddressList',
							path: 'macAddressList',
							component: MacAddressList,
							meta: {sectionName: 'registeredMacs'},
						},
						{
							name: 'unregisteredMacAddressList',
							path: 'unregisteredMacAddressList',
							component: UnregisteredMacAddressList,
							meta: {sectionName: 'registeredMacs'},
						},
					]
				},
				{
					name: 'registeredMacAddressBatchDetail',
					path: 'registeredMacAddressBatches/:id',
					component: RegisteredMacAddressBatchDetail,
					meta: {requiresAuth: true, sectionName: 'registeredMacs'},
				},
				// REPORTS
				{
					name: 'reports',
					path: 'reports',
					component: ReportsList,
					meta: {requiresAuth: true, sectionName: 'reports', remember: true},
				},
				{
					name: 'reportsOperator',
					path: 'reportsOperator/:id_operator/:id_report?',
					component: ReportsOperatorList,
					meta: {requiresAuth: true, sectionName: 'reports'},
				},
				// OPERATORS
				{
					name: 'operators',
					path: 'operators',
					component: OperatorList,
					meta: {requiresAuth: true, sectionName: 'operators', remember: true}
				},
				{
					name: 'operatorNew',
					path: 'operators/new',
					component: OperatorNew,
					meta: {requiresAuth: true, sectionName: 'operators', action: 'create'}
				},
				{
					name: 'operatorDetail',
					path: 'operators/:id',
					component: OperatorDetail,
					meta: {requiresAuth: true, sectionName: 'operators'}
				},
				{
					name: 'myOperatorDetail',
					path: 'myOperator/:id',
					component: OperatorDetail,
					meta: {requiresAuth: true, sectionName: 'operators'}
				},
				{
					name: 'operatorUserNew',
					path: 'operators/:operatorId/new-user',
					component: UserNew,
					meta: {requiresAuth: true, sectionName: 'users', action: 'create', selectOperators: true}
				},
				// USERS
				{
					name: 'users',
					path: 'users',
					component: UserList,
					meta: {requiresAuth: true, sectionName: 'users', selectOperators: true, remember: true}
				},
				{
					name: 'userNew',
					path: 'users/new',
					component: UserNew,
					meta: {requiresAuth: true, sectionName: 'users', action: 'create', selectOperators: true}
				},
				{
					name: 'userDetail',
					path: 'users/:id',
					component: UserDetail,
					meta: {requiresAuth: true, sectionName: 'users', selectOperators: true}
				},
				// BILLERS
				{
					name: 'billers',
					path: 'billers',
					component: BillerList,
					meta: {requiresAuth: true, sectionName: 'billers', selectOperators: true, remember: true}
				},
				{
					name: 'billerNew',
					path: 'billers/new',
					component: BillerNew,
					meta: {requiresAuth: true, sectionName: 'billers', action: 'create', selectOperators: true}
				},
				{
					name: 'billerDetail',
					path: 'billers/:id',
					component: BillerDetail,
					meta: {requiresAuth: true, sectionName: 'billers', selectOperators: true},
					children: [
						{
							name: 'billerDetailSubscribers',
							path: '/billers/:id/subscribers',
							component: BillerDetailSubscriberList,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'billerDetailServices',
							path: '/billers/:id/services',
							component: BillerDetailServiceList,
							meta: {sectionName: 'services'}
						},
						{
							name: 'billerDetailDevices',
							path: '/billers/:id/devices',
							component: BillerDetailDeviceList,
							meta: {sectionName: 'devices'}
						}
					]
				},
				// SUBSCRIBERS
				{
					name: 'subscribers',
					path: 'subscribers',
					component: SubscriberList,
					meta: {requiresAuth: true, sectionName: 'subscribers', selectOperators: true, remember: true}
				},
				{
					name: 'subscriberNew',
					path: 'subscribers/new',
					component: SubscriberNew,
					meta: {requiresAuth: true, sectionName: 'subscribers', action: 'create', selectOperators: true}
				},
				{
					name: 'subscriberDetailRemote',
					path: 'subscribers/remote/:remote',
					component: SubscriberDetail,
					meta: {requiresAuth: true, sectionName: 'subscribers', selectOperators: true},
				},
				{
					name: 'subscriberDetail',
					path: 'subscribers/:id',
					component: SubscriberDetail,
					redirect: 'subscribers/:id/settings',
					meta: {requiresAuth: true, sectionName: 'subscribers', selectOperators: true},
					children: [
						{
							name: 'subscriberDetailSettings',
							path: '/subscribers/:id/settings',
							component: SubscriberDetailSettings,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailBiller',
							path: '/subscribers/:id/biller',
							component: SubscriberDetailBiller,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailServices',
							path: '/subscribers/:id/services',
							component: SubscriberDetailServices,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailDevices',
							path: '/subscribers/:id/devices',
							component: SubscriberDetailDevices,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailProfiles',
							path: '/subscribers/:id/profiles',
							component: SubscriberDetailProfiles,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailChannelGroups',
							path: '/subscribers/:id/channel-groups',
							component: SubscriberDetailChannelGroups,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailPvrs',
							path: '/subscribers/:id/pvrs',
							component: SubscriberDetailPvrs,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailPeriodicPvrs',
							path: '/subscribers/:id/periodic-pvrs',
							component: SubscriberDetailPeriodicPvrs,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailFavoriteShows',
							path: '/subscribers/:id/favorite-shows',
							component: SubscriberDetailFavoriteShows,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailMessages',
							path: '/subscribers/:id/messages',
							component: SubscriberDetailMessages,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailAdvertisingBanners',
							path: '/subscribers/:id/advertising-banners',
							component: SubscriberDetailAdvertisingBanners,
							meta: {sectionName: 'subscribers'}
						},
						/* dočasně skryto (TW 36504111)
						{
							name: 'subscriberDetailNotifications',
							path: '/subscribers/:id/notifications',
							component: SubscriberDetailNotifications,
							meta: {sectionName: 'subscribers'}
						},
						*/
						{
							name: 'subscriberDetailDashboard',
							path: '/subscribers/:id/dashboard',
							component: SubscriberDetailDashboard,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailRestrictedChannels',
							path: '/subscribers/:id/restricted-channels',
							component: SubscriberDetailRestrictedChannels,
							meta: {sectionName: 'subscribers'}
						},
						{
							name: 'subscriberDetailPurchasedVodVideos',
							path: '/subscribers/:id/purchased-vod-videos',
							component: SubscriberDetailPurchasedVodVideos,
							meta: {sectionName: 'subscribers'}
						},
					]
				},
				// {
				// 	name: 'subscriberDetailDevices',
				// 	path: 'subscribers/:id/devices',
				// 	component: SubscriberDetail,
				// 	meta: {requiresAuth: true, sectionName: 'devices', selectOperators: true},
				// },
				// {
				// 	name: 'subscriberDetailChannelGroups',
				// 	path: 'subscribers/:id/channelGroups',
				// 	component: SubscriberDetail,
				// 	meta: {requiresAuth: true, sectionName: 'channelGroups', selectOperators: true},
				// },
				{
					name: 'subscriberNewDashboardCarousel',
					path: 'subscribers/:idSubscriber/dashboard/new',
					component: DashboardCarouselNew,
					meta: {requiresAuth: true, sectionName: 'subscribers'},
				},
				{
					name: 'subscriberDetailDashboardCarousel',
					path: 'subscribers/:idSubscriber/dashboard/:id',
					component: DashboardCarouselDetail,
					meta: {requiresAuth: true, sectionName: 'subscribers'},
				},
				// SUBSCRIBER PROFILE
				{
					name: 'subscriberProfileDetail',
					path: 'subscriberProfiles/:id',
					component: SubscriberProfileDetail,
					meta: {requiresAuth: true, sectionName: 'subscribers', selectOperators: true},
				},
				{
					name: 'subscriberProfileNew',
					path: ':idSubscriber/subscriberProfiles',
					component: SubscriberProfileNew,
					meta: {requiresAuth: true, sectionName: 'subscribers', selectOperators: true},
				},
				// DEVICES
				{
					name: 'devices',
					path: 'devices',
					component: DevicesList,
					meta: {requiresAuth: true, sectionName: 'devices', selectOperators: true, remember: true}
				},
				{
					name: 'deviceDetail',
					path: 'devices/:id',
					redirect: 'devices/:id/dashboard',
					component: DeviceDetail,
					meta: {requiresAuth: true, sectionName: 'devices', selectOperators: true},
					children: [
						{
							name: 'deviceDashboard',
							path: 'dashboard',
							component: DeviceDetailDashboard,
							meta: {sectionName: 'devices'}
						},
						{
							name: 'deviceActivity',
							path: 'activity',
							component: DeviceDetailActivity,
							meta: {sectionName: 'devices'}
						},
						{
							name: 'deviceHistory',
							path: 'history',
							component: DeviceDetailHistory,
							meta: {sectionName: 'devices'}
						},
						{
							name: 'deviceChannels',
							path: 'channels',
							component: DeviceDetailChannels,
							meta: {sectionName: 'channels'}
						},
						{
							name: 'deviceChannelGroups',
							path: 'channelGroups',
							component: DeviceDetailChannelGroups,
							meta: {sectionName: 'channelGroups'}
						},
						{
							name: 'deviceMacAddresses',
							path: 'macAddress',
							component: DeviceDetailMacAddresses,
							meta: {sectionName: 'devices'}
						},
            {
              name: 'deviceDetailBootConfigs',
              path: 'bootConfigs',
              component: DeviceDetailBootConfigs,
              meta: {sectionName: 'devices'}
            },
            {
              name: 'deviceMetadata',
              path: 'metadata',
              component: DeviceDetailMetadata,
              meta: {sectionName: 'devices'}
            },
					]
				},
				{
					name: 'createDeviceChannelGroup',
					path: 'devices/channel-group/:idDevice',
					component: ChannelGroupDetail,
					meta: {requiresAuth: true, isNewGroup: true, isDeviceGroup: true, sectionName: 'channelGroups', action: 'create'},
				},
				{
					name: 'createSubscriberChannelGroup',
					path: 'subscribers/create-channel-group/:idSubscriber',
					component: ChannelGroupDetail,
					meta: {requiresAuth: true, isNewGroup: true, isDeviceGroup: false, sectionName: 'channelGroups', action: 'create'},
				},
				{
					name: 'deviceChannelGroup',
					path: 'devices/channel-group/:idDevice/:idGroup',
					component: ChannelGroupDetail,
					meta: {requiresAuth: true, isNewGroup: false, isDeviceGroup: true, sectionName: 'channelGroups'},
				},
				{
					name: 'subscriberChannelGroup',
					path: 'subscribers/channel-group/:idGroup',
					component: ChannelGroupDetail,
					meta: {requiresAuth: true, isNewGroup: false, isDeviceGroup: false, sectionName: 'channelGroups'},
				},
				// CHANNELS
				{
					name: 'channels',
					path: 'channels',
					component: ChannelList,
					meta: {requiresAuth: true, sectionName: 'channels', selectOperators: true, remember: true}
				},
				{
					name: 'channelDetail',
					path: 'channels/:id',
					component: ChannelDetail,
					meta: {requiresAuth: true, sectionName: 'channels', selectOperators: true}
				},
				// PACKAGES
				{
					name: 'packages',
					path: 'packages',
					component: PackageList,
					meta: {requiresAuth: true, sectionName: 'packages', selectOperators: true, remember: true}
				},
				{
					name: 'packageNew',
					path: 'packages/new',
					component: PackageNew,
					meta: {requiresAuth: true, sectionName: 'packages', action: 'create', selectOperators: true}
				},
				{
					name: 'packageDetail',
					path: 'packages/:id',
					component: PackageDetail,
					meta: {requiresAuth: true, sectionName: 'packages', selectOperators: true}
				},
				// SERVICES
				{
					name: 'services',
					path: 'services',
					component: ServiceList,
					meta: {requiresAuth: true, sectionName: 'services', selectOperators: true, remember: true}
				},
				{
					name: 'serviceNew',
					path: 'services/new',
					component: ServiceNew,
					meta: {requiresAuth: true, sectionName: 'services', action: 'create', selectOperators: true}
				},
				{
					name: 'serviceDetail',
					path: 'services/:id',
					component: ServiceDetail,
					meta: {requiresAuth: true, sectionName: 'services', selectOperators: true}
				},
				// DOWNLOADS
				{
					name: 'downloads',
					path: 'downloads',
					component: Downloads,
					meta: {requiresAuth: true, sectionName: 'downloads', remember: true}
				},
				// TAGS
				{
					name: 'tags',
					path: 'tags',
					component: TagsList,
					meta: {requiresAuth: true, sectionName: 'tags', selectOperators: true, remember: true}
				},
				// OPERATOR TAGS
				{
					name: 'operatorTags',
					path: 'operatorTags',
					component: OperatorTagsList,
					meta: {requiresAuth: true, sectionName: 'operatorTags', remember: true}
				},
				// CODECS
				{
					name: 'codecs',
					path: 'codecs',
					component: CodecsList,
					meta: {requiresAuth: true, sectionName: 'codecs', remember: true}
				},
				// PROTOCOLS
				{
					name: 'protocols',
					path: 'protocols',
					component: ProtocolList,
					meta: {requiresAuth: true, sectionName: 'protocols', remember: true}
				},
				{
					name: 'protocolNew',
					path: 'protocols/new',
					component: ProtocolNew,
					meta: {requiresAuth: true, sectionName: 'protocols', action: 'create'}
				},
				{
					name: 'protocolDetail',
					path: 'protocols/:id',
					component: ProtocolDetail,
					meta: {requiresAuth: true, sectionName: 'protocols'}
				},
				// DEVICE TYPES
				{
					name: 'deviceTypes',
					path: 'deviceTypes',
					component: DeviceTypesList,
					meta: {requiresAuth: true, sectionName: 'deviceTypes', remember: true}
				},
				{
					path: 'deviceTypes/new',
					name: 'deviceTypeNew',
					redirect: { name: 'deviceTypeNewDescription' },
					component: DeviceTypeNew,
					meta: {requiresAuth: true, sectionName: 'deviceTypes', action: 'create'},
					children: [
						{
							name: 'deviceTypeNewDescription',
							path: 'description',
							component: DeviceTypeNewDescription,
							meta: {requiresAuth: true, sectionName: 'deviceTypes', action: 'create'},
						},
						{
							name: 'deviceTypeNewStreams',
							path: 'stream-profiles',
							component: DeviceTypeNewStreamProfiles,
							meta: {requiresAuth: true, sectionName: 'streamProfiles', action: 'create'},
						}
					]
				},
				{
					name: 'deviceTypeDetail',
					path: 'deviceTypes/:id',
					redirect: { name: 'deviceTypeDetailDescription' },
					component: DeviceTypeDetail,
					meta: {requiresAuth: true, sectionName: 'deviceTypes', remember: true},
					children: [
						{
							name: 'deviceTypeDetailDescription',
							path: 'description',
							component: DeviceTypeNewDescription,
							meta: {requiresAuth: true, sectionName: 'deviceTypes'},
						},
						{
							name: 'deviceTypeDetailStreams',
							path: 'stream-profiles',
							component: DeviceTypeNewStreamProfiles,
							meta: {requiresAuth: true, sectionName: 'deviceTypes'},
						}
					]
				},
				// DEVICE TYPE EVALUATIONS
				{
					name: 'deviceTypeEvaluations',
					path: 'deviceTypeEvaluations',
					component: DeviceTypeEvaluationsContainer,
					redirect: {name: 'deviceTypeEvaluationsList'},
					meta: {requiresAuth: true, sectionName: 'deviceTypes'},
					children: [
						{
							name: 'deviceTypeEvaluationsList',
							path: 'list',
							component: DeviceTypeEvaluationsList,
							meta: {requiresAuth: true, sectionName: 'deviceTypes', remember: true},
						},
						{
							name: 'deviceTypeEvaluationsTester',
							path: 'test',
							component: DeviceTypeEvaluationTester,
							meta: {requiresAuth: true, sectionName: 'deviceTypes'},
						},
					]
				},
				{
					name: 'deviceTypeEvaluationNew',
					path: 'deviceTypeEvaluations/new',
					component: DeviceTypeEvaluationNew,
					meta: {requiresAuth: true, sectionName: 'deviceTypes', action: 'create'},
				},
				{
					name: 'deviceTypeEvaluationDetail',
					path: 'deviceTypeEvaluations/:id',
					component: DeviceTypeEvaluationDetail,
					meta: {requiresAuth: true, sectionName: 'deviceTypes', remember: true},
				},
				// DEVICE CONFIGS - DeviceConfigsList
				{
					name: 'deviceConfigs',
					path: 'deviceConfigs',
					component: DeviceConfigsList,
					meta: {requiresAuth: true, sectionName: 'deviceConfigs', selectOperators: true, remember: true}
				},
				{
					name: 'deviceConfigNew',
					path: 'deviceConfigs/',
					component: DeviceConfigNew,
					redirect: { name: 'deviceConfigNewProperties' },
					meta: {requiresAuth: true, sectionName: 'deviceConfigs', action: 'create', selectOperators: true},
					children: [
						{
							name: 'deviceConfigNewProperties',
							path: 'properties',
							component: DeviceConfigDetailBasic,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs', action: 'create'},
						},
						{
							name: 'deviceConfigNewPlatform',
							path: 'platform',
							component: DeviceConfigDetailPlatform,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs', action: 'create'},
						},
						{
							name: 'deviceConfigNewDevice',
							path: 'device',
							component: DeviceConfigDetailDevice,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs', action: 'create'},
						},
						{
							name: 'deviceConfigNewPlayer',
							path: 'player',
							component: DeviceConfigDetailPlayer,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs', action: 'create'},
						}
						,
						{
							name: 'deviceConfigNewFunctions',
							path: 'functions',
							component: DeviceConfigDetailFeatures,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs', action: 'create'},
						}
					]
				},
				{
					name: 'deviceConfigDetail',
					path: 'deviceConfigs/:id',
					component: DeviceConfigDetail,
					redirect: { name: 'deviceConfigDetailProperties' },
					meta: {requiresAuth: true, sectionName: 'deviceConfigs', selectOperators: true},
					children: [
						{
							name: 'deviceConfigDetailProperties',
							path: 'properties',
							component: DeviceConfigDetailBasic,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs'},
						},
						{
							name: 'deviceConfigDetailPlatform',
							path: 'platform',
							component: DeviceConfigDetailPlatform,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs'},
						},
						{
							name: 'deviceConfigDetailDevice',
							path: 'device',
							component: DeviceConfigDetailDevice,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs'},
						},
						{
							name: 'deviceConfigDetailPlayer',
							path: 'player',
							component: DeviceConfigDetailPlayer,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs'},
						}
						,
						{
							name: 'deviceConfigDetailFunctions',
							path: 'functions',
							component: DeviceConfigDetailFeatures,
							meta: {requiresAuth: true, sectionName: 'deviceConfigs'},
						}
					]
				},
				// DEVICE PROFILES
				{
					name: 'deviceProfiles',
					path: 'deviceProfiles',
					component: DeviceProfilesList,
					meta: {requiresAuth: true, sectionName: 'deviceProfiles', selectOperators: true, remember: true}
				},
				{
					name: 'deviceProfileNew',
					path: 'deviceProfile/',
					component: DeviceProfileNew,
					redirect: { name: 'deviceProfileNewProperties' },
					meta: {requiresAuth: true, sectionName: 'deviceProfiles', action: 'create', selectOperators: true},
					children: [
						{
							name: 'deviceProfileNewProperties',
							path: 'properties',
							component: DeviceProfileDetailBasic,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles', action: 'create'},
						},
						{
							name: 'deviceProfileNewProtocols',
							path: 'protocols',
							component: DeviceProfileDetailProtocols,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles', action: 'create'},
						},
						{
							name: 'deviceProfileNewLinearProtocols',
							path: 'linearProtocols',
							component: DeviceProfileDetailLinearProtocols,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles', action: 'create'},
						},
						{
							name: 'deviceProfileNewNonLinearProtocols',
							path: 'nonLinearProtocols',
							component: DeviceProfileDetailNonLinearProtocols,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles', action: 'create'},
						}
					]
				},
				{
					name: 'deviceProfileDetail',
					path: 'deviceProfile/:id',
					component: DeviceProfileDetail,
					redirect: { name: 'deviceProfileDetailProperties' },
					meta: {requiresAuth: true, sectionName: 'deviceProfiles', selectOperators: true},
					children: [
						{
							name: 'deviceProfileDetailProperties',
							path: 'properties',
							component: DeviceProfileDetailBasic,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles'},
						},
						{
							name: 'deviceProfileDetailProtocols',
							path: 'protocols',
							component: DeviceProfileDetailProtocols,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles'},
						},
						{
							name: 'deviceProfileDetailLinearProtocols',
							path: 'linearProtocols',
							component: DeviceProfileDetailLinearProtocols,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles'},
						},
						{
							name: 'deviceProfileDetailNonLinearProtocols',
							path: 'nonLinearProtocols',
							component: DeviceProfileDetailNonLinearProtocols,
							meta: {requiresAuth: true, sectionName: 'deviceProfiles'},
						}
					]
				},
				// STREAM PROFILES
				{
					name: 'streamProfiles',
					path: 'streamProfiles',
					component: StreamProfilesList,
					meta: {requiresAuth: true, sectionName: 'streamProfiles', selectOperators: true, remember: true}
				},
				{
					name: 'streamProfileNew',
					path: 'streamProfiles/new',
					component: StreamProfileNew,
					meta: {requiresAuth: true, sectionName: 'streamProfiles', action: 'create', selectOperators: true}
				},
				{
					name: 'streamProfileDetail',
					path: 'streamProfiles/:id',
					component: StreamProfileDetail,
					meta: {requiresAuth: true, sectionName: 'streamProfiles', selectOperators: true}
				},
				// SERVICE WEIGHT CATEGORY
				{
					name: 'serviceWeightCategories',
					path: 'serviceWeightCategories',
					component: ServiceWeightCategoriesList,
					meta: {requiresAuth: true, sectionName: 'serviceWeightCategories', selectOperators: true, remember: true}
				},
				{
					name: 'serviceWeightCategoryNew',
					path: 'serviceWeightCategories/new',
					component: ServiceWeightCategoryNew,
					meta: {requiresAuth: true, sectionName: 'serviceWeightCategories', action: 'create'}
				},
				{
					name: 'serviceWeightCategoryDetail',
					path: 'serviceWeightCategories/:id',
					component: ServiceWeightCategoryDetail,
					meta: {requiresAuth: true, sectionName: 'serviceWeightCategories'}
				},
				// BUSINESS MODELS
				{
					name: 'businessModels',
					path: 'businessModels',
					component: BusinessModelList,
					meta: {requiresAuth: true, sectionName: 'businessModels', remember: true}
				},
				{
					name: 'businessModelsNew',
					path: 'businessModels/new',
					component: BusinessModelNew,
					meta: {requiresAuth: true, sectionName: 'businessModels', action: 'create'}
				},
				{
					name: 'businessModelsDetail',
					path: 'businessModels/:id',
					component: BusinessModelDetail,
					meta: {requiresAuth: true, sectionName: 'businessModels'}
				},
				// BRANDS
				{
					name: 'brands',
					path: 'brands',
					component: BrandsList,
					meta: {requiresAuth: true, sectionName: 'brands', remember: true}
				},
				{
					name: 'brandNew',
					path: 'brands/new',
					component: BrandNew,
					meta: {requiresAuth: true, sectionName: 'brands', action: 'create'}
				},
				{
					name: 'brandDetail',
					path: 'brands/:id',
					component: BrandDetail,
					meta: {requiresAuth: true, sectionName: 'brands'}
				},
				// CONTENT SOURCES
				{
					name: 'contentSources',
					path: 'content-sources',
					component: ContentSourceList,
					meta: {requiresAuth: true, sectionName: 'contentSources', selectOperators: true, remember: true}
				},
				{
					name: 'contentSourceNew',
					path: 'content-sources/new',
					component: ContentSourceNew,
					meta: {requiresAuth: true, sectionName: 'contentSources', action: 'create', selectOperators: true}
				},
				{
					name: 'contentSourceDetail',
					path: 'content-sources/:id',
					component: ContentSourceDetail,
					meta: {requiresAuth: true, sectionName: 'contentSources', selectOperators: true}
				},
				{
					name: 'contentSourceContentNew',
					path: 'content-sources/:id/content',
					component: ContentSourceContentNew,
					meta: {requiresAuth: true, sectionName: 'contentSources', action: 'update', selectOperators: true}
				},
				// CONTENT SOURCE MAINTENANCE WINDOW
				{
					name: 'contentSourceMaintenanceWindows',
					path: 'content-source-maintenance-windows',
					component: ContentSourceMaintenanceWindowLists,
					meta: {requiresAuth: true, sectionName: 'contentSources', selectOperators: true, remember: true}
				},
				{
					name: 'contentSourceMaintenanceWindowNew',
					path: 'content-source-maintenance-windows/new',
					component: ContentSourceMaintenanceWindowNew,
					meta: {requiresAuth: true, sectionName: 'contentSources', action: 'update', selectOperators: true}
				},
				{
					name: 'contentSourceMaintenanceWindowNewForContentSource',
					path: 'content-source-maintenance-windows/new/:idContentSource',
					component: ContentSourceMaintenanceWindowNew,
					meta: {requiresAuth: true, sectionName: 'contentSources', action: 'update', selectOperators: true}
				},
				{
					name: 'contentSourceMaintenanceWindowDetail',
					path: 'content-source-maintenance-windows/:id',
					component: ContentSourceMaintenanceWindowDetail,
					meta: {requiresAuth: true, sectionName: 'contentSources', selectOperators: true}
				},
				// MESSAGE TEMPLATES
				{
					name: 'messageTemplates',
					path: 'message-templates',
					component: MessageTemplateList,
					meta: {requiresAuth: true, sectionName: 'messages', selectOperators: true, remember: true}
				},
				{
					name: 'messageTemplateNew',
					path: 'message-templates/new',
					component: MessageTemplateNew,
					meta: {requiresAuth: true, sectionName: 'messages', action: 'create', selectOperators: true}
				},
				{
					name: 'messageTemplateDetail',
					path: 'message-templates/:id',
					component: MessageTemplateDetail,
					meta: {requiresAuth: true, sectionName: 'messages', selectOperators: true}
				},
				// MESSAGES
				{
					name: 'messages',
					path: 'messages',
					component: MessageList,
					meta: {requiresAuth: true, sectionName: 'messages', selectOperators: true, remember: true}
				},
				{
					name: 'messageDetail',
					path: 'messages/:id',
					component: MessageDetail,
					meta: {requiresAuth: true, sectionName: 'messages', selectOperators: true}
				},
				{
					name: 'messageNew',
					path: 'messages/new',
					component: MessageNew,
					meta: {requiresAuth: true, sectionName: 'messages', action: 'create', selectOperators: true}
				},
				{
					name: 'messageNewFromTemplate',
					path: 'messages/new-from-template/:id_template',
					component: MessageNew,
					meta: {requiresAuth: true, sectionName: 'messages', selectOperators: true}
				},
				// ADVERTISING BANNERS
				{
					name: 'advertisingBanners',
					path: 'advertisingBanners',
					component: AdvertisingBannerList,
					meta: {requiresAuth: true, sectionName: 'advertisingBanners', selectOperators: true, remember: true}
				},
				{
					name: 'advertisingBannerNew',
					path: 'advertisingBanners/new',
					component: AdvertisingBannerNew,
					meta: {requiresAuth: true, sectionName: 'advertisingBanners', action: 'create', selectOperators: true}
				},
				{
					name: 'advertisingBannerDetailParent',
					path: 'advertisingBanners/:id',
					component: AdvertisingBannerDetail,
					meta: {requiresAuth: true, sectionName: 'advertisingBanners', action: 'read', selectOperators: true},
					children: [
						{
							name: 'advertisingBannerDetail',
							path: 'settings',
							component: AdvertisingBannerDetailSettings,
							meta: {sectionName: 'advertisingBanners'}
						},
						{
							name: 'advertisingBannerDetailRecipients',
							path: 'recipients',
							component: AdvertisingBannerDetailRecipients,
							meta: {sectionName: 'advertisingBanners'}
						},
						]
				},

				// LOCALITIES
				{
					name: 'localities',
					path: 'localities',
					component: LocalitiesList,
					meta: {requiresAuth: true, sectionName: 'localities', remember: true}
				},
				{
					name: 'localitiesDetail',
					path: 'localities/:id',
					component: LocalitiesDetail,
					meta: {requiresAuth: true, sectionName: 'localities'}
				},
				{
					name: 'localitiesNew',
					path: 'localities/new',
					component: LocalitiesNew,
					meta: {requiresAuth: true, sectionName: 'localities', action: 'create'}
				},
				{
					name: 'customExports',
					path: 'customExports',
					component: CustomExportList,
					meta: {requiresAuth: true, sectionName: 'customExports'}
				},
				{
					name: 'customExportDetail',
					path: 'customExports/:id',
					component: CustomExportDetail,
					meta: {requiresAuth: true, sectionName: 'customExports'}
				},
				{
					name: 'dashboardCarousels',
					path: 'dashboardCarousels',
					component: DashboardCarouselList,
					meta: {requiresAuth: true, sectionName: 'dashboardCarousels'}
				},
				{
					name: 'dashboardCarouselNew',
					path: 'dashboardCarousels/new',
					component: DashboardCarouselNew,
					meta: {requiresAuth: true, sectionName: 'dashboardCarousels'}
				},
				{
					name: 'dashboardCarouselDetail',
					path: 'dashboardCarousels/:id',
					component: DashboardCarouselDetail,
					meta: {requiresAuth: true, sectionName: 'dashboardCarousels'}
				},
				// VERSION REDIRECT
				{
					name: 'versionRedirects',
					path: 'versionRedirects',
					component: VersionRedirectList,
					meta: {requiresAuth: true, sectionName: 'versionRedirects', remember: true}
				},
				{
					name: 'versionRedirectNew',
					path: 'versionRedirects/new',
					component: VersionRedirectNew,
					meta: {requiresAuth: true, sectionName: 'versionRedirects'}
				},
				{
					name: 'versionRedirectDetail',
					path: 'versionRedirect/:id',
					component: VersionRedirectDetail,
					meta: {requiresAuth: true, sectionName: 'versionRedirects'}
				},
				// THEMATIC GROUPS
				{
					name: 'thematicGroups',
					path: 'thematicGroups',
					component: ThematicGroupList,
					meta: {requiresAuth: true, sectionName: 'thematicGroups', remember: true}
				},
				{
					name: 'thematicGroupNew',
					path: 'thematicGroups/new',
					component: ThematicGroupNew,
					meta: {requiresAuth: true, sectionName: 'thematicGroups'}
				},
				{
					name: 'thematicGroupDetail',
					path: 'thematicGroups/:id',
					component: ThematicGroupDetail,
					meta: {requiresAuth: true, sectionName: 'thematicGroups'}
				},
				// INITIAL PROCESS SETUP
				{
					name: 'initialProcessSetup',
					path: 'initialProcessSetup',
					component: InitialProcessSetupList,
					meta: {requiresAuth: true, sectionName: 'initialProcessSetup', remember: true}
				},
				{
					name: 'initialProcessSetupNew',
					path: 'initialProcessSetup/new',
					component: InitialProcessSetupNew,
					meta: {requiresAuth: true, sectionName: 'initialProcessSetup'}
				},
				{
					name: 'initialProcessSetupDetail',
					path: 'initialProcessSetup/:id',
					component: InitialProcessSetupDetail,
					meta: {requiresAuth: true, sectionName: 'initialProcessSetup'}
				},
				// BLACKOUT CONTENTS
				{
					name: 'blackoutContents',
					path: 'blackoutContents',
					component: BlackoutContentList,
					meta: {requiresAuth: true, sectionName: 'blackoutContents', remember: true}
				},
				{
					name: 'blackoutContentNew',
					path: 'blackoutContents/new',
					component: BlackoutContentNew,
					meta: {requiresAuth: true, sectionName: 'blackoutContents'}
				},
				{
					name: 'blackoutContentDetail',
					path: 'blackoutContents/:id',
					component: BlackoutContentDetail,
					meta: {requiresAuth: true, sectionName: 'blackoutContents'}
				},
				{
					name: 'vodProviders',
					path: 'vodProviders',
					component: VodProvidersList,
					meta: {requiresAuth: true, sectionName: 'vod', remember: true}
				},
				{
					name: 'vodProvidersDetail',
					path: 'vodProviders/:id',
					redirect: 'vodProviders/:id/settings',
					component: VodProvidersDetail,
					meta: {requiresAuth: true, sectionName: 'vod'},
					children: [
						{
							name: 'vodProvidersSettings',
							path: 'settings',
							component: VodProvidersSettings,
							meta: { sectionName: 'vod' }
						},
						{
							name: 'vodProvidersPackages',
							path: 'packages',
							component: VodProvidersPackages,
							meta: {sectionName: 'vod'}
						},
						{
							name: 'vodProvidersVideos',
							path: 'videos',
							component: VodProvidersVideos,
							meta: {sectionName: 'vod'}
						},
					]
				},
				{
					name: 'vodPackages',
					path: 'vodPackages',
					component: VodPackagesList,
					meta: { requiresAuth: true, sectionName: 'vod', remember: true }
				},
				{
					name: 'vodPackagesDetail',
					path: 'vodPackages/:id',
					redirect: 'vodPackages/:id/settings',
					component: VodPackagesDetail,
					meta: { requiresAuth: true, sectionName: 'vod' },
					children: [
						{
							name: 'vodPackagesSettings',
							path: 'settings',
							component: VodPackagesSettings,
							meta: { sectionName: 'vod' }
						},
						{
							name: 'vodPackagesVideos',
							path: 'videos',
							component: VodProvidersVideos,
							meta: { sectionName: 'vod' }
						},
						{
							name: 'vodPackagesPrices',
							path: 'prices',
							component: VodPackagePrices,
							meta: { sectionName: 'vod' }
						},
						{
							name: 'vodPackagesServices',
							path: 'services',
							component: VodPackagesServices,
							meta: { sectionName: 'vod' }
						},
					]
				},
				{
					name: 'vodVideos',
					path: 'vodVideos',
					component: VodVideosList,
					meta: { requiresAuth: true, sectionName: 'vod', remember: true }
				},
				{
					name: 'vodVideosDetail',
					path: 'vodVideos/:id',
					redirect: 'vodVideos/:id/settings',
					component: VodVideosDetail,
					meta: { requiresAuth: true, sectionName: 'vod' },
					children: [
						{
							name: 'vodVideosSettings',
							path: 'settings',
							component: VodVideosSettings,
							meta: { sectionName: 'vod' }
						},
						{
							name: 'vodVideosPackages',
							path: 'packages',
							component: VodProvidersPackages,
							meta: { sectionName: 'vod' }
						},
						{
							name: 'vodVideosPrices',
							path: 'prices',
							component: VodVideoPrices,
							meta: { sectionName: 'vod' }
						},
						]
				},
				{
					name: 'vodEpisodes',
					path: 'vodEpisodes/:id',
					component: VodEpisodesList,
					meta: {requiresAuth: true, sectionName: 'vod', remember: true}
				},
				{
					name: 'currencies',
					path: 'currencies',
					component: CurrenciesList,
					meta: { requiresAuth: true, sectionName: 'currencies', remember: true }
				},
				{
					name: 'currenciesDetail',
					path: 'currencies/:id',
					component: CurrenciesDetail,
					meta: { requiresAuth: true, sectionName: 'currencies' }
				},
				// ADVERTISING PROVIDERS
				{
					name: 'advertisingProviders',
					path: 'advertisingProviders',
					component: AdvertisingProvidersList,
					meta: {requiresAuth: true, sectionName: 'advertisingProviders'}
				},
				{
					name: 'advertisingProviderNew',
					path: 'advertisingProviders/new',
					component: AdvertisingProviderNew,
					meta: { requiresAuth: true, sectionName: 'advertisingProviders', action: 'create'}
				},
				{
					name: 'advertisingProviderDetail',
					path: 'advertisingProviders/:id',
					component: AdvertisingProviderDetail,
					redirect: 'advertisingProviders/:id/settings',
					meta: { requiresAuth: true, sectionName: 'advertisingProviders' },
					children: [
						{
							name: 'advertisingProviderSettings',
							path: 'settings',
							component: AdvertisingProviderSettings,
							meta: {sectionName: 'advertisingProviders'}
						},
						{
							name: 'advertisingProviderChannelGroups',
							path: 'channelGroups',
							component: AdvertisingProviderChannelGroupsList,
							meta: { sectionName: 'advertisingProviders' },
						},
					],
				},
				{
					name: 'advertisingProviderChannelGroupDetail',
					path: 'advertisingProvidersChannelGroups/:id',
					component: AdvertisingProviderChannelGroupDetail,
					redirect: 'advertisingProvidersChannelGroups/:id/settings',
					meta: { sectionName: 'advertisingProviders' },
					children: [
						{
							name: 'advertisingProviderChannelGroupDetailSettings',
							path: 'settings',
							component: AdvertisingProviderChannelGroupDetailSettings,
							meta: {sectionName: 'advertisingProviders'}
						},
						{
							name: 'advertisingProviderChannelGroupDetailChannels',
							path: 'channels',
							component: AdvertisingProviderChannelGroupDetailChannelsList,
							meta: {sectionName: 'advertisingProviders'}
						},
					],
				},
				// DEVICE BOOT CONFIGS
        {
          name: 'deviceBootConfigs',
          path: 'deviceBootConfigs',
          component: DeviceBootConfigsList,
          meta: { requiresAuth: true, sectionName: 'deviceBootConfigs' }
        },
        {
          name: 'deviceBootConfigNew',
          path: 'deviceBootConfigs/new/:idDevice?',
          component: DeviceBootConfigNew,
          meta: { requiresAuth: true, sectionName: 'deviceBootConfigs', action: 'create' }
        },
        {
          name: 'deviceBootConfigDetail',
          path: 'deviceBootConfigs/:id',
          component: DeviceBootConfigDetail,
          meta: { requiresAuth: true, sectionName: 'deviceBootConfigs' }
        },
				// LANDING PAGE
				{
					name: 'landingPage',
					path: 'landingPage',
					component: LandingPage,
					meta: { requiresAuth: false, sectionName: 'landingPage' }
				},
				{
					name: 'landingPageEdit',
					path: 'landingPage/:id/edit',
					component: LandingPageForm,
					meta: { requiresAuth: false, sectionName: 'landingPage' }
				},
				{
					name: 'images',
					path: 'images',
					component: ImagesList,
					meta: { requiresAuth: true, sectionName: 'images' }
				},
				{
					name: 'imagesNew',
					path: 'images/new',
					component: ImageNew,
					meta: {requiresAuth: true, sectionName: 'images'}
				},
				{
					name: 'imagesDetail',
					path: 'images/:id',
					component: ImageDetail,
					meta: {requiresAuth: true, sectionName: 'images'}
				},
				{ //This item has to be last
					name: 'temporary',
					path: '*',
					component: SubscriberList
				},
			]
		},
	]
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth) && (!router.app.$store.getters.isAuthenticated)) {
		next({
			path: '/login',
			query: {redirect: to.fullPath}
		})
	} else if (router.app.$store.getters.isAuthenticated && to.query.redirect) {
		next({ path: to.query.redirect });
	} else if (router.app.$store.getters.isAuthenticated && to.query.download) {
		window.location.href = to.query.download;
		next({ name: 'subscribers' })
	} else if (to.name === 'operatorDetail' && store.getters.getUserRole === OPERATOR && Number(to.params.id) !== Number(store.getters.operatorId)) {
		next({ name: 'subscribers' })
	} else if (to.name === 'operatorUserNew' && store.getters.getUserRole === OPERATOR && Number(to.params.operatorId) !== Number(store.getters.operatorId)) {
		next({ name: 'subscribers' })
	} else {
		next()
	}
});

router.afterEach((to) => {
	if (to.meta.remember) {
		router.app.$store.dispatch(SET_SETTING, { module: 'global', key: 'last-path', settings: to.fullPath })
		//localStorage.setItem('last-path', to.fullPath)
	}
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js